<template>
  <div id="q-app" @click.right="activePointer">
    <router-view />
    <Oops @cancel="giveUp" @action="retry" v-show="oops" />
    <Overlay />
  </div>
</template>
<script>
import { LocalStorage } from "quasar";
import Oops from "./components/Oops.vue";
import Overlay from "./components/Overlay.vue";
import { browserValidation, screenValidation } from "./libs/device";
export default {
  name: "App",
  components: { Oops, Overlay },
  async preFetch({ store, redirect, currentRoute }) {
    try {
      if (currentRoute.query.forceOrigin === "true") {
        LocalStorage.set("forceOrigin", currentRoute.query.forceOrigin);
      }
      await store.dispatch("app/siteConfiguration");
    } catch (e) {
      if (e === "404") {
        redirect(e);
      }
    }
  },
  computed: {
    oops: {
      get() {
        return this.$store.state.app.oops;
      },
      set(val) {
        this.$store.commit("app/oops", val);
      },
    },
    fromAgent: {
      get() {
        return this.$store.state.app.fromAgent;
      },
    },
  },
  async mounted() {
    await this.setBrowserInvalid();
    await this.screenError();
    this.listenForCardViwed();
    this.$store.state.app;
  },
  methods: {
    giveUp() {
      this.$q.localStorage.remove("sid");
      this.oops = false;
      top.document.location = "/";
    },
    retry() {
      this.oops = false;
      setTimeout(async () => {
        document.location.reload();
      }, 500);
    },
    async setBrowserInvalid() {
      this.$store.commit("app/browserInvalid", browserValidation());
    },
    async screenError() {
      this.$store.commit("app/screenErrorType", screenValidation());
    },
    listenForCardViwed() {
      window.addEventListener("message", this.onViewStateChange, false);
    },
    unListenForCardViwed() {
      window.removeEventListener("message", this.onViewStateChange);
    },
    onViewStateChange(event) {
      if (event.data.showSecondaryText) {
        this.$store.commit("meeting/showSecondaryText", true);
        this.unListenForCardViwed();
      }
    },
    activePointer(ev) {
      if (this.fromAgent) {
        ev.preventDefault();
        window.parent.postMessage({ togglePointer: true }, "*");
      }
    },
  },
  meta() {
    return this.$store.state.app.config?.metas ?? {};
  },
  beforeDestroy() {
    this.unListenForCardViwed();
  },
};
</script>

<style>
@import "./css/sandals/sandals-icons.css";
</style>
